module.exports = __webpack_public_path__ + "img/k12_feature3.e20d11c7.png";